import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { removeSpacesAtStart } from '@/modules/common/application/string';
import { EditedUser, User, UserGroup } from '@/modules/common/types';

export const getUserLabel = function (user: Partial<EditedUser>): string {
  const fullName =
    `${removeSpacesAtStart(user.firstName || '')} ${removeSpacesAtStart(user.lastName || '')}`.trim();
  return fullName || user.email || '';
};

export const getStackholderLabel = function (
  stakeholder: Pick<User, 'firstName' | 'lastName' | 'email'>
): string {
  return `${stakeholder.firstName || ''} ${stakeholder.lastName || ''}`.trim() || stakeholder.email;
};

export const getExternalUserSchema = (t: TFunction, users: Partial<User>[]) => {
  return Yup.object().shape({
    language: Yup.string().default('de').required(t('fieldWarnings.requiredWarning')),
    email: Yup.string()
      .default('')
      .email(t('fieldWarnings.emailWarning'))
      .required(t('fieldWarnings.requiredWarning'))
      .test(
        'userAlreadyExists',
        t('fieldWarnings.emailExistsWarning'),
        (value) => users.find((user) => user.email === value) === undefined
      ),
  });
};

export const getNameById = (id: string, users: Partial<EditedUser>[]) => {
  const user = users.find((u) => u.id === id);
  return user?.fullName || '';
};

export const getUserGroupById = (id: string, usersGroups: Partial<UserGroup>[]) => {
  const usersGroup = usersGroups.find((u) => u.id === id);
  return usersGroup?.name || '';
};
